// Meta
export const APP_NAME = 'New Zealand Maritime Museum';
export const APP_NAME_FULL = 'New Zealand Maritime Museum | Hui Te Ananui A Tangaroa';
